module.exports = __webpack_public_path__ + "images/b24a24bb018e446380bacc19ca980c4c-OrangeRewardsbutton.png";